// extracted by mini-css-extract-plugin
export default {"wrapper":"fAbuy","channelWrap":"doIW9","channel":"ruKso","channelImg":"W4ISy","slidingWrap":"YNpmp","descriptionWrap":"zsRnY","descriptionArrow":"i87yS","descriptionContent":"B8oXR"};